$( document ).ready( function() {

  // if ( !$( 'body' ).hasClass( 'single-report' ) ) return;

  $( 'article .nav-tabs .nav-item:first-child .nav-link' ).trigger( 'click' );

});
